import { useDatabase } from "../../hooks/useDatabase";

import { FaLinkedin } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

export default function SocialLinks() {
    const db = useDatabase();

    return (
        <div className="icon-list">
            <div className="icon">
                <a href={db.settings.socials.linkedin} target="_blank" rel="noreferrer"><FaLinkedin style={{ width: "25px", height: "25px" }} /></a>
            </div>
            <div className="icon">
                <a href={"mailto:" + db.settings.socials.email}><MdEmail style={{ width: "30px", height: "30px", marginTop: "-1.5px" }} /></a>
            </div>
        </div>
    )
}